module.exports = __webpack_public_path__ + "static/media/mealManageLogo.1e415ef1.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mealManageLogo.PNG
// module id = 519
// module chunks = 0